export const OPEN_DROPDOWN = 'OPEN_DROPDOWN'
export const CLOSE_DROPDOWN = 'CLOSE_DROPDOWN'

export const openDropdown = (id) => {
    return { type: OPEN_DROPDOWN, payload: {id} }
}

export const closeDropdown = (id) => {
    return { type: CLOSE_DROPDOWN, payload: {id} }
}



// WEBPACK FOOTER //
// ./src/actions/dropdown.js